// Module
var code = "<span class=\"vui-input-group\" ng-transclude></span>\n";
// Exports
module.exports = code;